/* eslint-disable */
import {put, takeEvery} from "redux-saga/effects";
import ExVideoEvents from "../events/ExVideoEvents";
import {
    LoadAllContextPhrase,
    LoadAllContextPhraseComplete,
    UpdateContextPhrase,
    UpdateContextPhraseComplete,
    UpdateContextPhraseFailed,
    EditVideoCaption,
    EditVideoCaptionComplete,
    EditVideoCaptionFailed,
    RerunSTT,
    RerunSTTComplete,
    RerunSTTFailed,
    LoadProcessStatus,
    LoadProcessStatusComplete,
    LoadProcessStatusRepeat,
    LoadProcessStatusRepeatComplete,
    UpdateVideoOption,
    UpdateVideoOptionComplete,
    GetVideoOptionComplete,
    UpdateCaptionPublicState,
    UpdateCaptionPublicStateComplete,
    UpdateCaptionPublicStateFailed,
    LoadStatistics,
    LoadStatisticsComplete,
    UpdateStatistics,
    UpdateStatisticsComplete,
    UpdateStatisticsFailed,
    LoadPopularRanking,
    LoadPopularRankingComplete,
} from "../actions/ExVideoActions";
import ExVideoApi from "../apis/ExVideoApi";
import {Video} from "../../models/video";
import {PopularRanking, Statistics} from "../../models/statistics";

// 辞書情報取得
function* LoadAllContextPhraseWorker({language}: ReturnType<typeof LoadAllContextPhrase>) {
    const phrase: string[] = yield ExVideoApi.getAllContextPhrase(language);
    yield put(LoadAllContextPhraseComplete(phrase));
}

// 辞書更新
function* UpdateContextPhraseWorker({language, phrases}: ReturnType<typeof UpdateContextPhrase>) {
    const result: any = yield ExVideoApi.updateContextPhrase(language, phrases);
    if (result.response && result.response.status !== 200) {
        yield put(UpdateContextPhraseFailed(result.stack));
   } else {
        yield put(UpdateContextPhraseComplete(result));
   }
}

// ビデオSTT編集
function* EditVideoCaptionWorker({caption}: ReturnType<typeof EditVideoCaption>) {
    const result: any = yield ExVideoApi.EditVideoCaption(caption);
    if (result.response && result.response.status !== 200) {
        yield put(EditVideoCaptionFailed(result.stack));
   } else {
        yield put(EditVideoCaptionComplete(result));
   }
}

// ビデオSTT再実行
function* RerunSTTWorker({videoId, videoLanguage}: ReturnType<typeof RerunSTT>) {
    const result: any = yield ExVideoApi.RerunSTT(videoId, videoLanguage);
    if (result.response && result.response.status !== 200) {
        yield put(RerunSTTFailed(result.stack));
   } else {
        yield put(RerunSTTComplete());
   }
}

// ビデオSTT再実行
function* UpdateCaptionPublicStateWorker({
    userId,
    videoId,
    publicCaption,
    muteState,
}: ReturnType<typeof UpdateCaptionPublicState>) {
    const result: any = yield ExVideoApi.UpdateCaptionPublicState(
        userId,
        videoId,
        publicCaption,
        muteState
    );
    if (result.response && result.response.status !== 200) {
        yield put(UpdateCaptionPublicStateFailed(result.stack));
   } else {
        yield put(UpdateCaptionPublicStateComplete());
   }
}

// ビデオ処理情報取得
function* LoadProcessStatusWorker({userId}: ReturnType<typeof LoadProcessStatus>) {
    const videos: Video[] = yield ExVideoApi.getProcessStatus(userId);
    yield put(LoadProcessStatusComplete(videos));
}

// ビデオ処理情報取得（定期）
function* LoadProcessStatusRepeatWorker({userId}: ReturnType<typeof LoadProcessStatusRepeat>) {
    const videos: Video[] = yield ExVideoApi.getProcessStatusRepeat(userId);
    yield put(LoadProcessStatusRepeatComplete(videos));
}

// ビデオ再生オプション取得
const session = sessionStorage;

function ToBoolean(string: string) {
    return string.toLowerCase() === "true";
}

function* GetVideoOptionWorker() {
    if (session) {
        const isPlay = session.getItem("isPlay");
        const isVisibleCaption = session.getItem("isVisibleCaption");
        const isMuted = session.getItem("isMuted");
        const viewPattern = session.getItem("viewPattern");
        if (isPlay && isVisibleCaption && isMuted && viewPattern) {
            yield put(
                GetVideoOptionComplete(
                    ToBoolean(isPlay),
                    ToBoolean(isVisibleCaption),
                    ToBoolean(isMuted),
                    Number(viewPattern)
                )
            );
       } else {
            session.setItem("isPlay", "true");
            session.setItem("isVisibleCaption", "false");
            session.setItem("isMuted", "false");
            session.setItem("viewPattern", "1");
            yield put(GetVideoOptionComplete(true, false, false, 1));
       }
        console.log(
            "ExVideoSaga: GetVideoOptionWorker/ isPlay: ",
            isPlay,
            ", isVisibleCaption: ",
            isVisibleCaption,
            ", isMuted: ",
            isMuted,
            ", viewPattern: ",
            viewPattern
        );
   }
}

// ビデオ再生オプション更新
function* UpdateVideoOptionWorker({
    isPlay,
    isVisibleCaption,
    isMuted,
    viewPattern,
}: ReturnType<typeof UpdateVideoOption>) {
    session.setItem("isPlay", String(isPlay));
    session.setItem("isVisibleCaption", String(isVisibleCaption));
    session.setItem("isMuted", String(isMuted));
    session.setItem("viewPattern", String(viewPattern));
    console.log(
        "ExVideoSaga: UpdateVideoOptionWorker/ isPlay: ",
        isPlay,
        ", isVisibleCaption: ",
        isVisibleCaption,
        ", isMuted: ",
        isMuted,
        ", viewPattern: ",
        viewPattern
    );
    yield put(UpdateVideoOptionComplete());
}

// 統計情報取得
function* LoadStatisticsWorker({startDate, endDate}: ReturnType<typeof LoadStatistics>) {
    const stats: Statistics = yield ExVideoApi.getStatistics(startDate, endDate);
    yield put(LoadStatisticsComplete(stats));
}

// 統計情報更新
function* UpdateStatisticsWorker({
    userId,
    videoId,
    videoTag,
    videoTitle,
    videoUrl,
    viewDurationMillis,
    newWatch,
}: ReturnType<typeof UpdateStatistics>) {
    const result: any = yield ExVideoApi.UpdateStatistics(
        userId,
        videoId,
        videoTag,
        videoTitle,
        videoUrl,
        viewDurationMillis,
        newWatch
    );
    if (result.response && result.response.status !== 200) {
        yield put(UpdateStatisticsFailed(result.stack));
   } else {
        yield put(UpdateStatisticsComplete());
   }
}

// 人気ランキング情報取得
function* LoadPopularRankingWorker({startDate, endDate}: ReturnType<typeof LoadPopularRanking>) {
    const stats: PopularRanking = yield ExVideoApi.getPopularRanking(startDate, endDate);
    yield put(LoadPopularRankingComplete(stats));
}

export default function* ExVideoSaga() {
    yield takeEvery(ExVideoEvents.LoadAllContextPhraseStarted, LoadAllContextPhraseWorker);
    yield takeEvery(ExVideoEvents.UpdateContextPhraseStarted, UpdateContextPhraseWorker);
    yield takeEvery(ExVideoEvents.EditVideoCaptionStarted, EditVideoCaptionWorker);
    yield takeEvery(ExVideoEvents.RerunSTTStarted, RerunSTTWorker);
    yield takeEvery(ExVideoEvents.UpdateCaptionPublicStateStarted, UpdateCaptionPublicStateWorker);
    yield takeEvery(ExVideoEvents.LoadProcessStatusStarted, LoadProcessStatusWorker);
    yield takeEvery(ExVideoEvents.LoadProcessStatusRepeatStarted, LoadProcessStatusRepeatWorker);
    yield takeEvery(ExVideoEvents.GetVideoOptionStarted, GetVideoOptionWorker);
    yield takeEvery(ExVideoEvents.UpdateVideoOptionStarted, UpdateVideoOptionWorker);
    yield takeEvery(ExVideoEvents.LoadStatisticsStarted, LoadStatisticsWorker);
    yield takeEvery(ExVideoEvents.UpdateStatisticsStarted, UpdateStatisticsWorker);
    yield takeEvery(ExVideoEvents.LoadPopularRankingStarted, LoadPopularRankingWorker);
}
